@if ((showInlineModal || addEntity.data.action === 'edit') && addEntity && addEntity.data) {
  <fuse-groups-form-dialog
    [closeEmitter]="saveEmitter"
    [dataByInput]="isJoiningExistingLearner ? joinLearner : addEntity"
    [groupNameClassroomSelected]="groupNameClassroomSelected"
    [groupNameSelected]="groupNameSelected"
    [isJoiningExistingLearner]="isJoiningExistingLearner"
    [learnersList]="learnersList"
    (isFormValid)="isFormValid($event)"
    (submitInside)="submitInside($event)"
    (saveInProgress)="saveInProgressEmit()"
    class="id-groups-form-dialog">
  </fuse-groups-form-dialog>
}

@if (addEntity.data.action !== 'edit') {
  <div
    class="groups-inline-modal__actions"
    mat-dialog-actions>
    <!--    A un moment donné ici on créé des classes-->
    @if (!isgroupOrClassroomFilterActivate() && isCreateAuthorized()) {
      <button
        class="groups-inline-modal__add-button add-group-button add"
        data-e2e="group-inline-modal-add"
        [disabled]="(!groupFormIsValid && showInlineModal) || isAddLearnerQuotaDoneAndNotGar"
        (click)="openModalFormInline()">
        <mat-icon svgIcon="add"></mat-icon>
        <span>&nbsp;{{'groups-management.' + addEntity.data.title | translate}} {{addLearnerButtonInfo}}</span>
      </button>
    }
    @if (canAddNewLearner()) {
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openModalFormInline()"
          data-e2e="group-inline-modal-open-1"
          [ngClass]="isAddLearnerQuotaDoneAndNotGar?'menu-button-add-learner-disabled':''"
          [disabled]="isAddLearnerQuotaDoneAndNotGar">
          <span>{{'groups-management.add_new_learner' | translate}} </span> @if (isAddLearnerButtonInfoAllowed) {
          <span
          > &nbsp; {{addLearnerButtonInfo}} {{'groups-management.add_new_learner_info' | translate}}</span>
        }
      </button>
      <button mat-menu-item (click)="openModalFormInline(true)" data-e2e="group-inline-modal-open-2">
        {{'groups-management.add_existing_learner' | translate}}
      </button>
    </mat-menu>
    @if (isgroupOrClassroomFilterActivate() && isCreateAuthorized() && isJoinAuthorized()) {
      <button
          data-e2e="group-inline-modal-menu"
        [disabled]="!groupFormIsValid && showInlineModal"
        [matMenuTriggerFor]="menu"
        aria-label="add entity"
        class="groups-inline-modal__add-learner-button add-learner-button add">
        <mat-icon svgIcon="add"></mat-icon>
        <span>&nbsp;{{'groups-management.' + joinLearner.data.title | translate}} </span>
      </button>
    }
  } @else {
    @if (isgroupOrClassroomFilterActivate() && isJoinAuthorized()) {
      <button
          data-e2e="group-inline-modal-open-inline"
        [disabled]="!groupFormIsValid && showInlineModal"
        (click)="openModalFormInline(true)"
        aria-label="add entity"
        class="groups-inline-modal__add-learner-button add-learner-button add">
        <mat-icon svgIcon="add"></mat-icon>
        <span>&nbsp;{{'groups-management.' + joinLearner.data.title | translate}}</span>
      </button>
    }
  }
</div>
}